module.exports = __webpack_public_path__ + "static/media/Pallion_logo.3d4cd1fb.jpg";